/*
 * @Author: 刘枫
 * @Date: 2020-10-27 10:40:26
 * @Last Modified by: 刘枫
 * @Last Modified time: 2020-12-03 09:52:14
 */


import { post, post2, get } from 'utils/post';

// v2版本把商品添加到购物车
export function addGoodsCartV2(data) {
  return post2('/api/shoppingCart/add', data)
}

// v2版本 把商品从购物车删除
export function deleteGoodsCartV2(data) {
  return post2('/api/shoppingCart/delete', data)
}

// 我的购物车列表
export function getCartList(data) {
  return post('/api/cart/cart_list', data)
}
// v2版本 我的购物车列表
export function getCartListV2(data) {
  return post2('/api/shoppingCart/list', data)
}

// v2版本 清空购物车
export function cleanCartV2(data) {
  return post2('/api/shoppingCart/clean', data)
}

// v2版本 购物车结算
export function cartCheckV2(data) {
  return post2('/api/cart/cartCheck', data)
}

// v2版本 更新购物车商品数量
export function updateNumV2(data) {
  return post2('/api/shoppingCart/update', data)
}

// 创建订单
//type :1购物车创建订单,2立即购买创建订单
export function createOrder(data, type) {
  if (type == 1) {
    return post2('/api/order/createOrderCart', data)
  } else {
    return post2('/api/order/createOrderBuyNow', data)
  }
}

// 获取运费模板
export function freight(data) {
  return post2('/api/order/getShipping', data)
}

// 商品立即购买，校验购物车-返回用户抵扣的购物券和自营购物积分
export function cartBuy(data) {
  return post2('/api/cart/checkCart', data)
}

// 获取付款方式
export function getPayMentType(data) {
  return post('/api/shop/paymentType', data)
}
//获取微信号和手机号的接口是:
export function getWeiPhone() {
  return post('/api/order/get_wei_phone')
}



// WEBPACK FOOTER //
// ./src/api/goodsCart.js